const e = (t) => t;
export {
  e as mutable
};
